import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import FormModel from "./models/FormModel";

interface IMaritalStatus {
  id: number;
  name: string;
}

export const initialFormData = { id: 0, name: "" };

function MaritalStatus() {
  const [maritalstatuses, setMaritalStatuses] = useState<IMaritalStatus[]>([]);
  const [initial, setInitial] = useState<IMaritalStatus>(initialFormData);

  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/marital-status", { headers }).then((res) => {
      if (res.status === 200) setMaritalStatuses(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/marital-status/" + id, { headers }).then((res) => {
      if (res.status === 200) setMaritalStatuses(res.data);
    });
  };

  const handleEdit = ({ id, name }: IMaritalStatus) => {
    const maritalstatus: IMaritalStatus = { id, name };
    setInitial(maritalstatus);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">MaritalStatus</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All MaritalStatuses
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Name</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {maritalstatuses.length ? (
                      maritalstatuses.map((maritalstatus, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{maritalstatus.name}</td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(maritalstatus)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(maritalstatus.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={3}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{ setMaritalStatuses, initial, setInitial, modalShow, setModalShow }}
      />
    </div>
  );
}

export default MaritalStatus;
